import { Component,Inject,ViewChild } from '@angular/core';
import { Platform,Events,MenuController,AlertController } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { IonicPage, NavController, NavParams,LoadingController } from 'ionic-angular';
import { Dashboard } from '../pages/dashboard/dashboard';
import {Updatepage} from '../pages/updatepage/updatepage'

import { Storagehelper } from '../providers/storagehelper'
import { PageText } from '../pages/page-text/page-text'
import { PageSlider } from '../pages/page-slider/page-slider'
import { PageAudio } from '../pages/page-audio/page-audio'
import { PageVideo } from '../pages/page-video/page-video'
import { ScreenOrientation } from '@ionic-native/screen-orientation';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { OpenNativeSettings } from '@ionic-native/open-native-settings';
import { CategorypagesPage } from '../pages/categorypages/categorypages'
import { ReminderPage } from '../pages/reminder/reminder'
import {FavoritepagesPage} from '../pages/favoritepages/favoritepages'
var cordova:any;
@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  rootPage:any = Dashboard;
  private infoShown;
  @ViewChild('mycontent') nav;
  public menuItem;
  private loading;
  public showFavText;
  public favoriteTasks;
  public favortieSettings;
  public reminderSetting;
  public headerSettings;


  constructor(public platform: Platform, public statusBar: StatusBar, splashScreen: SplashScreen,public loader:LoadingController,public storage:Storagehelper,public events:Events,private screenOrientation: ScreenOrientation,public menuctrl:MenuController,public alertCtrl:AlertController,public nativesetting:OpenNativeSettings,private iab: InAppBrowser) {
    platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.

       if(!platform.is('core') && !platform.is('mobileweb')) {
          statusBar.styleDefault();
          splashScreen.hide();
          if(platform.is('android')){

            this.statusBar.overlaysWebView(false);
          }else{

            this.statusBar.overlaysWebView(true);
          }

          this.screenOrientation.lock(this.screenOrientation.ORIENTATIONS.PORTRAIT);

          cordova.plugins.notification.local.on('click',()=>{ 
         let alert1=this.alertCtrl.create({
                    title:"Snorkel",
                    message:'Är du säker på att du vill ta bort?',
                    buttons:[
                              {
                                text:'Nej',
                                role:'cancel',
                                handler:()=>{
                                }
                              },{
                                text:'Ja',
                                handler:()=>{
                                }
                              }
                            ]
                })
                   alert1.present();
      })
        }


      
      
    });
    // this.infoShown=false;
    this.favortieSettings={menuText:"Favoriter",'menuBackground':'#fbae5a'};
    this.reminderSetting={menuText:"Paminn mig",'menuBackground':'#fbae5a'};
    this.headerSettings={'menuBackground':'#000'};
    this.favoriteTasks=[];
    this.showFavText=false;
    this.loading=this.loader.create({
      spinner:"ios",
      cssClass:"dreamLoader"
    });
    // this.loading.present();
    this.menuItem=[];
    this.events.subscribe('app:loadedDataFromServer',()=>{
      this.loadAppMenu();

    })
    this.events.subscribe('app:dismissLoading',()=>{
      this.loading.dismiss();

    })

    this.events.subscribe('app:loadFavoriteItems',()=>{
      this.loadFavoriteItems();
    })
    this.events.subscribe('app:changeHeaderBackground',()=>{
      console.log("Change header now");

      this.setToolbarBackgrounds();
    })


    this.events.subscribe('app:changePage',(menuItem)=>{
      console.log("got change page event");  
        this.gotopage(menuItem);
    })

    this.events.subscribe('app:goBack',(menuItem)=>{
      console.log("pop the page");  
        this.goBack();
    })
       this.loadFavoriteItems();
        // this.showNoDisturb();
   //  if(!(this.platform.is('core') || this.platform.is('mobileweb'))) {
   //   this.showNoDisturb();
   // }
   this.setToolbarBackgrounds();
   this.bindReminderEvent();
  }  

  bindReminderEvent(){

  }

  checkIfShared(){
     var urlPath=window.location.href.split("?");
     if(urlPath.length>1){
       var taskid=window.location.href.split("?")[1].split("=")[1];
       console.log(this.menuItem);
       this.storage.getStorageItem("pagelist").then((data)=>{
           var pageDetail=data.filter((e,i)=>{
             return e.Id==taskid;
           })
           if(pageDetail.length>0){
             pageDetail[0].bckButtonAvailable=true;
             this.gotopage(pageDetail[0]);

           }
       })
     }else{
        this.menuctrl.open();
     }

  }

  showNoDisturb(){

            let alert=this.alertCtrl.create({
              title:"Snorkel",
              cssClass:"alert-settings",
              message:'Tänk på att ställa in mobilen på "Stör ej eller ljudlöst',
              buttons:[{
                text:'Inställningar',
                role:'cancel',
                handler:()=>{
                  this.nativesetting.open("settings");
                }
              },
              {
                text:'Stäng',
                role:'cancel'
              }]
            })
            alert.present();
  }


  loadAppMenu(){
    return this.storage.getStorageItem("menuCategories").then((data)=>{
      console.log("Menu items are");
        if(data!=null){
          data=data.filter((e,i)=>{
            return e.onMenu==1
          })
        }
       this.storage.getStorageItem("coachdetail").then((content)=>{
         this.storage.getStorageItem("staticTexts").then(menuTexts=>{
             // var textproperty={bck:"",title:"",menu_category:-1};

             // var bck=menuTexts.filter((e,i)=>{
             //   return e.textid==1;
             // });
             // if(bck.length>0){
             //   textproperty.bck=bck[0].menuBackground;
             //   textproperty.menu_category=bck[0].category;
             //   textproperty.title=bck[0].staticText;
             // }

            
             // if(textproperty.menu_category==-1){
             //    data.push({ category_title:  textproperty.title,category_title_color:textproperty.bck, PageTypeID: 'myList', bckButtonAvaliable: false, customcat:true});
             // }else{

                
             //    var selectedCat=data.filter((e,i)=>{
             //      return e.category_id==textproperty.menu_category;
             //    })
             //    if(selectedCat.length>0)
             //      selectedCat[0].menuPages.push({ category_title:  textproperty.title,category_title_color:textproperty.bck, PageTypeID: 'myList', bckButtonAvaliable: false, customcat:true});
             //     else{
             //       data.push({ category_title:  textproperty.title,category_title_color:textproperty.bck, PageTypeID: 'myList', bckButtonAvaliable: false, customcat:true});
             //     }
             // }

            // var textproperty={bck:"",title:"",menu_category:-1};

            //  var bck=menuTexts.filter((e,i)=>{
            //    return e.textid==2;
            //  });
            //  if(bck.length>0){
            //    textproperty.bck=bck[0].menuBackground;
            //    textproperty.menu_category=bck[0].category;
            //    textproperty.title=bck[0].staticText;
             
            //  }

            //  if(textproperty.menu_category==-1){
            //     data.push({category_title:textproperty.title,category_title_color:textproperty.bck,PageTypeID:'mythought',bckButtonAvaliable:false, customcat:true});
            //  }else{
            //     var selectedCat=data.filter((e,i)=>{
            //       return e.category_id==textproperty.menu_category;
            //     })
            //     if(selectedCat.length>0){
            //       selectedCat[0].menuPages.push({category_title:textproperty.title,category_title_color:textproperty.bck,PageTypeID:'mythought',bckButtonAvaliable:false, customcat:true});
            //     }
            //    else{
            //      data.push({category_title:textproperty.title,category_title_color:textproperty.bck,PageTypeID:'mythought',bckButtonAvaliable:false, customcat:true});
            //    }
            //  }

             
            var textproperty={bck:"",title:"",menu_category:-1};

            var bck=menuTexts.filter((e,i)=>{
               return e.textid==4;
            });
             
            if(bck.length>0){
               textproperty.bck=bck[0].menuBackground;
               textproperty.title=bck[0].staticText;
            }
             

              
              data.push({category_title:textproperty.title,category_title_color:textproperty.bck,PageTypeID:'favorite',bckButtonAvaliable:false, customcat:true});
             
            textproperty={bck:"",title:"",menu_category:-1};

            var bck=menuTexts.filter((e,i)=>{
               return e.textid==6;
            });
             
            if(bck.length>0){
               textproperty.bck=bck[0].menuBackground;
               textproperty.title=bck[0].staticText;
            }
             

              
              data.push({category_title:textproperty.title,category_title_color:textproperty.bck,PageTypeID:'reminder',bckButtonAvaliable:false, customcat:true});
             


             

              this.menuItem=data;
              console.log(this.menuItem);
               
        

              bck=menuTexts.filter((e,i)=>{
                     return e.textid==5;
              })[0];

              this.headerSettings={'menuBackground':bck.menuBackground};
              this.checkIfShared();
              this.loading.dismiss();
              this.setToolbarBackgrounds();
               var ionheader:any;
              ionheader=document.getElementsByTagName("ion-header");
              
                ionheader[1].style.opacity="1";
              
         })
        
       })
        
      
    })
  }

  toggleFavText(){
    if(this.showFavText==false){
      this.showFavText=true;
    }else{
      this.showFavText=false;
    } 
 
  }

  goBack(){
    this.nav.pop();
  }

  gotopage(menuItem){

    if(menuItem.categoryid==undefined || menuItem.categoryid==null)
      menuItem.categoryid=-1;
    

    if(menuItem!=undefined){}
     if(menuItem.externalLink!=undefined){
        const browser = this.iab.create(menuItem.externalLink,'_blank');
        browser.show();
       return;
     }else{

         // var page=this.menuItem.filter((e,i)=>{
         //   return e.LinkedPageId==menuItem.LinkedPageId
         // })[0];
         if(menuItem.pagedetail!=undefined)
           menuItem.PageTypeID=menuItem.pagedetail[0].PageTypeID;

     }

    if(!menuItem.bckButtonAvailable || menuItem.bckButtonAvailable==undefined){
      menuItem.bckButtonAvailable=false;
    }
    
    if(menuItem.LinkedPageId==undefined){
      menuItem.LinkedPageId=menuItem.Id;
    }

    if(menuItem.PageTypeID==1){
       this.nav.push(PageText,{
          pageID:menuItem.LinkedPageId,
          removebckbutton:!menuItem.bckButtonAvailable,
          categoryID:menuItem.categoryid
        }).then(() => {
          this.removePreviousPage(menuItem.bckButtonAvailable);
      });

    }else if(menuItem.PageTypeID==3){
       this.nav.push(PageSlider,{
          pageID:menuItem.LinkedPageId,
          removebckbutton:!menuItem.bckButtonAvailable,
          categoryID:menuItem.categoryid
        }).then(() => {
          this.removePreviousPage(menuItem.bckButtonAvailable);
      });

    }else if(menuItem.PageTypeID==2){
       this.nav.push(PageAudio,{
          pageID:menuItem.LinkedPageId,
          removebckbutton:!menuItem.bckButtonAvailable,
          categoryID:menuItem.categoryid
        }).then(() => {
          this.removePreviousPage(menuItem.bckButtonAvailable);
      });

    }else if(menuItem.PageTypeID==4){
       this.nav.push(PageVideo,{
          pageID:menuItem.LinkedPageId,
          removebckbutton:!menuItem.bckButtonAvailable,
          categoryID:menuItem.categoryid
        }).then(() => {
          this.removePreviousPage(menuItem.bckButtonAvailable);
        });

    }else if(menuItem.PageTypeID=="reminder"){
      this.nav.push(ReminderPage).then(()=>{
        this.removePreviousPage(menuItem.bckButtonAvaliable);
      })
    }else if(menuItem.PageTypeID=="favorite"){
      this.nav.push(FavoritepagesPage).then(()=>{
        this.removePreviousPage(menuItem.bckButtonAvaliable);
      })
    }

    
    this.loadFavoriteItems();
    this.menuctrl.close();
    setTimeout(()=>{
      this.setToolbarBackgrounds();
    },100);

  }

  setToolbarBackgrounds(){
    var toolbars:any;
    toolbars=document.getElementsByClassName("toolbar-background");
    for(var i=1;i<toolbars.length;i++){
      toolbars[i].style.background="#"+this.headerSettings.menuBackground;
    }
  }

  removePreviousPage(bckButtonAvailable){
    if(bckButtonAvailable==false){
     const index = this.nav.getActive().index;
     console.log(index);
     for(var i=0;i<(index-1);i++){
       this.nav.remove(0);
     }
      this.nav.remove(0);
    }
  }

  loadFavoriteItems(){
    this.storage.getStorageItem("favoriteTasks").then((data)=>{
      if(data!=null)
        this.favoriteTasks=data;
    })
  }

  public hexToRgbA(hex){
    var c;
    hex="#"+hex;
    if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
        c= hex.substring(1).split('');
        if(c.length== 3){
            c= [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c= '0x'+c.join('');
        return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+',0.7)';
    }else{
      return 'rgba("0,0,0,0.7")';
    }
   
}

  public closeMenu(){
    this.menuctrl.close();
  }


  public openSubMenu(menu){

      this.activateMenu(menu);
      this.nav.push(CategorypagesPage,{
        categoryId:menu.category_id
      });
      this.menuctrl.close();
  }

  public activateMenu(menu){
    this.menuItem.forEach((e,i)=>{
        e.opened=false;
      })
      menu.opened=true;
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts